/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { VideoEditorCreateEditSocialPublishMutationRequest, VideoEditorCreateEditSocialPublishMutationResponse, VideoEditorCreateEditSocialPublishPathParams, VideoEditorCreateEditSocialPublish401, VideoEditorCreateEditSocialPublish403, VideoEditorCreateEditSocialPublish404 } from "../models/VideoEditorCreateEditSocialPublish";

export function getVideoEditorCreateEditSocialPublishUrl(id: VideoEditorCreateEditSocialPublishPathParams["id"]) {
  const res = { method: 'POST', url: `/video-editor/v1/edits/${id}/social-publish` as const }
  return res
}

/**
 * @description Starts publishing the edit video to the given social connection.
 * You can call this while the video is still rendering:
 * - If the video is already ready, publishing starts right away.
 * - If not, the publish is created in a waiting state (`waitingForMedia: true`) and continues automatically once rendering finishes. If rendering fails, the publish is marked as failed.
 * Use the returned upload (and upload status endpoints) to follow progress. You do not need a playback URL from `GET .../render/video-url` before calling this.
 * @summary Publish an edit to a social connection (allowed before the video is ready)
 * {@link /video-editor/v1/edits/:id/social-publish}
 */
export async function videoEditorCreateEditSocialPublish(id: VideoEditorCreateEditSocialPublishPathParams["id"], data: VideoEditorCreateEditSocialPublishMutationRequest, config: Partial<RequestConfig<VideoEditorCreateEditSocialPublishMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<VideoEditorCreateEditSocialPublishMutationResponse, ResponseErrorConfig<VideoEditorCreateEditSocialPublish401 | VideoEditorCreateEditSocialPublish403 | VideoEditorCreateEditSocialPublish404>, VideoEditorCreateEditSocialPublishMutationRequest>({ method : "POST", url : getVideoEditorCreateEditSocialPublishUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}